var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhotoRollIconColored = function SvgPhotoRollIconColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#photo_roll_icon_colored_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19,
    r: 16,
    fill: "url(#photo_roll_icon_colored_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.25 15.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5m-.75 2.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.25 12.25A2.25 2.25 0 0 0 11 14.5v9a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 29 23.5v-9a2.25 2.25 0 0 0-2.25-2.25zm13.5 1.5h-13.5a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h3.235l5.16-5.159a2.25 2.25 0 0 1 3.181 0l2.674 2.674V14.5a.75.75 0 0 0-.75-.75m0 10.5h-8.143l4.098-4.098a.75.75 0 0 1 1.06 0l3.665 3.664a.75.75 0 0 1-.68.434",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "photo_roll_icon_colored_svg__b",
    x1: 20,
    x2: 20,
    y1: 3,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "photo_roll_icon_colored_svg__a",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7091_137870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7091_137870",
    result: "shape"
  })))));
};
export default SvgPhotoRollIconColored;